/**
 * @deprecated use ServerZoneType instead
 */
export var ServerZone;
(function (ServerZone) {
  ServerZone["US"] = "US";
  ServerZone["EU"] = "EU";
  /**
   * Add for session-replay-browser migration from analytics-type v1.x.
   */
  ServerZone["STAGING"] = "STAGING";
})(ServerZone || (ServerZone = {}));